import { createResource } from 'lib/domonda-resource';
import { getValidatableInvoiceContainers } from 'lib/api/invoiceContainers';

export const documentsOverviewResource = createResource(getValidatableInvoiceContainers, {
  documentState: 'needForAction',
  fullTextQuery: null,
  orderBy: null,
  orderDescending: null,
  PageNumber: null,
  PageSize: null,
  invoiceDetailsToQuery: null,
  invoiceDetailQuery: null,
});
